import iagPerformanceDefaults from '../k6t81b-kz/config.js';

export default {
  ...iagPerformanceDefaults,
  includes: [...iagPerformanceDefaults.includes, 'k6t81b-kz'],
};
